import { Relationship, RelationshipType } from './relationship.model'
import { User } from './user.model'

export class RelationshipForm {
  public userId = ''
  public relatedUser = new User()
  public relationship = ''

  fill (relationship: Relationship) {
    this.userId = relationship.userId
    this.relatedUser = new User().cast(relationship.relatedUser)
    this.relationship = RelationshipType[relationship.relationship]
    return this
  }

  generateSelectType () {
    return Object.keys(RelationshipType)
      .filter(key => !isNaN(parseInt(key, 10)))
      .map((el, index) => {
        return {
          value: RelationshipType[index],
          label: new Relationship().getTypeLabel(index)
        }
      })
  }

  isParent () {
    return this.relationship === RelationshipType[RelationshipType.parent]
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/models/relationship-form.model.ts